class NullIndexBuffer {
		unlock(indexBuffer) {}
}

export { NullIndexBuffer };
